<template>
    <div class="courses-single-page bg-dark-blue">
        <div class="container">
            <div v-if="coursePackage" class="row">
                <div class="col-lg-12">
                    <div class="content-page-wrap clearfix">
                        <div class="card mt-3 mb-3">
                            <div class="container-fluid">
                                <div class="course-single tab-content">
                                    <div class="row">
                                        <div class="col d-flex flex-column justify-content-between">
                                            <div class="container-fluid d-flex align-items-center mb-3">
                                                <div class="d-flex flex-column">
                                                    <label>Image (370x270)</label>
                                                    <input type="file" @change="onFileChange($event.target, coursePackage, 'image')" v-if="!coursePackage.imageFileName" style="background-color: white" class="" />
                                                    <div v-if="coursePackage.imageFileName">
                                                        <button type="button" v-on:click="removeImage">Remove</button>
                                                        <img :src="coursePackage | s3url('image')" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-between align-items-end">
                                                <div class="container-fluid">
                                                    <label class="mr-2">Name</label>
                                                    <input type="text" v-model="coursePackage.name" />
                                                </div>
                                                <div class="container-fluid w-25">
                                                    <label class="mr-2">Enabled</label>
                                                    <input type="checkbox" v-model="coursePackage.enabled" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="d-flex justify-content-end">
                                                <button class="btn-add" style="background-color: black; color: white" v-on:click="save">Save</button>

                                            </div>

                                            <div class="container-fluid included-courses bd-dark-blue">
                                                <div class="title">
                                                    Included courses
                                                </div>
                                                <ul style="height: 150px; overflow-y: auto; overflow-x: hidden;">
                                                    <li v-for="course in includedCourses">
                                                        <div class="row">
                                                            <div class="col-6">
                                                                {{course.siteName}}
                                                            </div>
                                                            <div class="col-6">
                                                                {{course.name}}
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="container-fluid">
                                        <label>Description short</label>
                                        <input type="text" v-model="coursePackage.descriptionShort" />
                                    </div>
                                    <div class="container-fluid">
                                        <label>Description long</label>
                                        <textarea type="text" v-model="coursePackage.descriptionLong" rows="5"></textarea>
                                    </div>
                                    <div class="d-flex mb-3">
                                        <div class="container-fluid">
                                            <label>Price</label>
                                            <input type="number" v-model.number="coursePackage.price" />
                                        </div>
                                        <div class="container-fluid">
                                            <label>Price (USD)</label>
                                            <input type="number" v-model.number="coursePackage.priceUsd" />
                                        </div>
                                    </div>

                                    <div class="container-fluid">
                                        <div class="d-flex justify-content-between">

                                            <div class="title">
                                                Courses
                                            </div>
                                            <div class="site-select" v-show="userRole == 'admin'">
                                                <select v-model="selectedSite">
                                                    <option v-for="site in sites" :value="site">{{site.name}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="table-responsive">
                                            <table class="table" style="background-color: white">
                                                <thead>
                                                    <tr>
                                                        <th>Id</th>
                                                        <th>Site</th>
                                                        <th>Course Name</th>
                                                        <th>Category</th>
                                                        <th>Included</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="course in filteredCourses">
                                                        <td>{{ course.id }}</td>
                                                        <td>{{ course.siteName }}</td>
                                                        <td>{{ course.name }}</td>
                                                        <td>{{ course.category }}</td>
                                                        <td>
                                                            <input v-model="course.allocated" type="checkbox" />
                                                        </td>
                                                    </tr>
                                                </tbody>

                                            </table>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<style scoped>
</style>

<script>
    import MixinsFileUploads from '../../mixinsFileUploads';

    export default {
        name: 'AdminCoursePackagesDetails',
        mixins: [MixinsFileUploads],
        computed: {
            coursePackageId() {
                return this.$route.params.id
            },
            filteredCourses() {
                var filtered = [];
                if (this.userRole && this.userRole == 'admin') {
                    for (var i = 0; i < this.courses.length; i++) {
                        var currentCourse = this.courses[i];
                        if (currentCourse.siteId == this.selectedSite.id) {
                            filtered.push(currentCourse);
                        }
                    }
                }
                else {
                    filtered = this.courses;
                }
                return filtered;
            },
            includedCourses() {
                var included = [];
                for (var i = 0; i < this.courses.length; i++) {
                    var current = this.courses[i];
                    if (current.allocated) {
                        included.push(current);
                    }
                }
                return included;
            },
            userRole() {
                var roles = this.$store.state.user.roles;
                return roles[0];
            }
        },
        data: function () {
            return {
                coursePackage: null,
                courses: [],
                sites: [],
                selectedSite: null,
            }
        },
        methods: {
            async save() {
                await this.uploadFilesAsync(this.coursePackage, "image");
                await this.uploadPackageDetails();
            },
            async uploadPackageDetails() {
                this.coursePackage.courses = this.courses.filter(x => x.allocated).map(function (x) { return { id: x.id } });
                this.coursePackage = await this.web('/coursePackages', "Uploading package data", this.coursePackage);
            },
            removeImage() {
                this.coursePackage.imageFileName = null;
            }
        },
        async mounted() {
            var coursePackage = await this.web('/coursePackages/' + this.coursePackageId, "Loading course package");
            var courses = await this.web("/courses?filters=admin&filters=all", "Loading courses");
            if (this.userRole == 'admin') {
                this.sites = await this.web("/sites", "Loading sites");
                this.selectedSite = this.sites[0];
            }

            for (var i = 0; i < courses.length; i++) {
                var course = courses[i];
                course.allocated = coursePackage.courses.findIndex(x => x.id == course.id) > -1;
            }

            this.courses = courses;
            this.coursePackage = coursePackage;

            var crumbs = {};
            crumbs["/admin/coursePackages"] = "Admin Course Packages";
            crumbs["/admin/coursePackages/" + this.coursePackageId] = (this.coursePackageId == 0 ? "New Course Package" : this.coursePackage.name);
            this.$store.commit("breadCrumbs", crumbs);
        }
    }
</script>